interface WaterResistanceProps {
  waterResistanceType: any
  openWaterResistance: () => void
}

const WaterResistance: React.FC<WaterResistanceProps> = ({
  waterResistanceType,
  openWaterResistance,
}) =>
  waterResistanceType ? (
    <div className="my-8 text-16 leading-6">
      <div className="uppercase text-ui-darkest-grey font-bold mb-4">
        WATER RESISTANCE
      </div>
      <div className="text-dark-grey text-left">
        {waterResistanceType} metre water resistant
        <span
          className="underline cursor-pointer ml-1"
          onClick={openWaterResistance}
        >
          Learn more
        </span>
      </div>
    </div>
  ) : null

export default WaterResistance
